class PredictiveSearch extends MenuDrawer {
  constructor() {
    super();

    this.cachedResults = {};
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.input = this.querySelector('input[role="combobox"]');
    this.predictiveSearchResults = this.querySelector(
      'predictive-search-results',
    );
    this.clearButton = this.querySelector('[data-clear-button]');
    this.closeButton = this.querySelector('[data-close-button]');
    this.defaultResources = this.querySelector('[data-default-results]');

    this.setupEventListeners();

    if (this.dataset.extended) {
      this.openMenuDrawer();
      this.setOffset();

      this.summary.addEventListener('click', () => {
        this.querySelector('input[name="q"]').focus();
      });
      window.addEventListener('resize', () => {
        this.setOffset();
      });
    }
  }

  openMenuDrawer() {
    this.details.classList.add('open');
    this.details.setAttribute('open', true);

    bodyScroll.lock(this.summary);

    setTimeout(() => {
      this.input.focus();
    }, 50);
  }

  bindEvents() {}

  setupEventListeners() {
    const form = this.querySelector('form');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.clearButton?.addEventListener('click', this.clearQuery.bind(this));
    this.closeButton?.addEventListener('click', (event) => {
      this.close(false, true);
    });
    this.summary.addEventListener('click', (event) => {
      if (this.details.classList.contains('open')) {
        this.close(false, true);
      } else {
        this.openMenuDrawer();
      }

      event.preventDefault();
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  clearQuery() {
    this.input.value = '';

    this.onChange();
  }

  hasQuery() {
    return !!this.getQuery().length;
  }

  onChange() {
    let searchTerm = this.getQuery();

    this.toggleClearBtn(searchTerm);

    if (!this.hasQuery()) {
      this.appendDefaultResources();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.hasQuery() || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!this.hasQuery()) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    // setTimeout(() => {
    //   if (!this.contains(document.activeElement)) this.close(false, true);
    // });
  }

  toggleClearBtn(searchTerm) {
    if (!this.clearButton) return;

    this.clearButton.classList.toggle('hidden', searchTerm.length === 0);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm,
      )}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent(
        'resources[limit]',
      )}=5&${encodeURIComponent(
        'resources[options][fields]',
      )}=title,product_type,variants.title,vendor,body&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  populateSearchResults(html = '') {
    this.predictiveSearchResults.innerHTML = html;

    yotpoWidgetsContainer?.initWidgets(false);
  }

  renderSearchResults(resultsMarkup) {
    this.populateSearchResults(resultsMarkup);
    this.open();
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false, closeModal = false) {
    if (this.dataset.extended) return;

    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('open');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);

    bodyScroll.clear();

    if (closeModal) {
      this.details.classList.remove('open');

      this.closeAnimation(this.details);
    }
  }

  closeAnimation(detailsElement, delay = 400) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < delay) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  appendDefaultResources() {
    if (!this.defaultResources) return;

    this.renderSearchResults(this.defaultResources.innerHTML);
  }

  setOffset() {
    const notFoundSection = document.querySelector('[data-404]');
    const predictiveSearch = this.querySelector('predictive-search-results');
    const searchBody = this.querySelector('[data-search-body]');

    const offset = getOffsetTop(notFoundSection) + notFoundSection.offsetHeight;
    const offsetSearch =
      searchBody.offsetHeight + predictiveSearch.offsetHeight;

    searchBody.style.setProperty('--offset', `${offset}px`);
    notFoundSection.style.setProperty('--offset', `${offsetSearch}px`);
  }
}

customElements.define('predictive-search', PredictiveSearch);
